import { Injectable } from '@angular/core';
import { CustomerInfoTO } from 'app/core/store/customer-info/customer-info.interface';
import { logger } from 'app/core/util/logger';
import { from, Observable, of, timer } from 'rxjs';
import { appSettings } from 'app/appSettings';
import { ContractDetailsTO } from '../../store/contract-details/contract-details.interface';
import { util } from '../../util/util';

import { default as getCustomerInfoResult } from './responses/getCustomerInfo';
import { RestService } from './rest.service';
import { catchError, switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

interface ValidatePoNumberParams {
  poNumber: string;
  required: boolean;
  unique: string;
  mask: string;
  senderRefNumber: string;
  fromId: string;
  toId: string;
  etmOrderNumber: string;
}

interface LineRefParams {
  lineReferenceId: string;
  referenceRequired: boolean;
  mask: string;
}

@Injectable({ providedIn: 'root' })
export class ContractDetailsRestService {
  constructor(private restService: RestService) {}

  getContractDetails(selectedCustomerId: string): Observable<ContractDetailsTO> {
    return this.restService.get<ContractDetailsTO>(`/Customer/getContractDetails?date=${util.formatDate(new Date())}&CustomerId=${selectedCustomerId}`);
  }

  /**
   *
   *
   * Return values:
   * {  "success": true  }
   * or not according to mask
   * { "Origin":"SAP","Type":"FUNCTIONAL","Message":"Functional SAP Error: Reference does not match mask","SubMessages":[] }
   * or required
   * {"Origin":"SAP","Type":"FUNCTIONAL","Message":"Functional SAP Error: Reference must be filled","SubMessages":[]}
   * or unique
   * ???????????????
   *
   * @param {ValidatePoNumberParams} params
   * @returns {Observable<boolean>}
   */
  validatePoNumber(params: ValidatePoNumberParams): Observable<{ success: boolean; message: string }> {
    return this.restService.post<any>('/Contract/validatePoNumber', params).pipe(
      catchError(async (error: HttpErrorResponse) => {
        return from(util.getErrorMessage(error)).pipe(
          switchMap(errorMessage => of({ success: false, message: errorMessage.message }))
        );
      })
    );
  }

  validateLineRef(params: LineRefParams): Observable<{ success: boolean; message: string }> {
    return timer(500).pipe(
      switchMap(() => {
        return this.restService.post<any>('/Contract/validateLineReference', params).pipe(
          catchError(async (error: HttpErrorResponse) => {
            return from(util.getErrorMessage(error)).pipe(
              switchMap(errorMessage => of({ success: false, message: errorMessage.message }))
            );
          })
        );
      })
    );
  }

  getCustomerInfo(selectedCustomerId: string): Observable<CustomerInfoTO> {
    if (appSettings.USE_MOCK_REST_DATA) {
      logger.log('MOCK REST getCustomerInfo');
      return of(getCustomerInfoResult as CustomerInfoTO);
    } else {
      return this.restService.get<CustomerInfoTO>(`/Customer/getCustomerInfo?date=${util.formatDate(new Date())}&CustomerId=${selectedCustomerId}`, false, false, selectedCustomerId);
    }
  }
}
